/* perf 30.09 D-10: logika plakietki dostawy przeniesiona z inline snippets/shop-benefits-block.liquid (5,4 KB, 28 wstawek
   Liquid na każdej karcie) do pliku z defer. Dane (teksty dni, godzina graniczna, teksty przedsprzedaży i braku, język,
   stany wariantów) daje snippet w <script type="application/json" data-sv-benefits-config data-block-id>; logika
   bez zmian (z poprawkami B-07 i M-2). Start jak dotąd po DOMContentLoaded; każdy blok raz. */
(function () {
  // perf 30.09 (R2-04): wspólny rejestr dla wszystkich wykonań pliku - dwie instancje bloku = dwa <script src>, każdy blok startuje raz
  var started = window.__svBenefitsStarted || (window.__svBenefitsStarted = new WeakSet());

  function initBenefits(configEl) {
    if (started.has(configEl)) return;
    started.add(configEl);
    var blockId = configEl.getAttribute('data-block-id');
    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }
    run(blockId, config);
  }

  function run(blockId, config) {
    var deliveryBadge = document.getElementById('delivery-badge-' + blockId);
    var deliveryBadgeText = document.getElementById('delivery-badge-text-' + blockId);

    if (!deliveryBadge || !deliveryBadgeText) return;

    /* perf 30.09 C-24: pulsowanie kropki stoi, gdy kropki nie ma na ekranie (klasa na samej kropce - update() nadpisuje
       className plakietki). Bez IntersectionObserver pulsuje zawsze, jak dotąd. */
    var pulseDot = deliveryBadge.querySelector('.pulse-dot');
    if (pulseDot && 'IntersectionObserver' in window) {
      new IntersectionObserver(function(entries) {
        pulseDot.classList.toggle('sv-anim-off', !entries[entries.length - 1].isIntersecting);
      }).observe(pulseDot);
    }

    var settings = {
      cutoffHour: config.cutoffHour,
      preorderText: config.preorderText,
      outOfStockText: config.outOfStockText,
      lang: config.lang,
      deliveryTexts: config.deliveryTexts || {},
      shipOn: config.shipOn || '',
      shipDays: config.shipDays || []
    };

    var variantData = config.variants || {};

    function formatDate(dateString) {
      if (!dateString || dateString === '') return '';
      try {
        var parts = dateString.split('T')[0].split('-');
        if (parts.length !== 3) return '';
        var day = parseInt(parts[2], 10);
        var month = parseInt(parts[1], 10) - 1;
        var months;
        if (settings.lang === 'pl') {
          months = ['stycznia', 'lutego', 'marca', 'kwietnia', 'maja', 'czerwca',
                    'lipca', 'sierpnia', 'września', 'października', 'listopada', 'grudnia'];
          return day + ' ' + months[month];
        } else {
          months = ['January', 'February', 'March', 'April', 'May', 'June',
                    'July', 'August', 'September', 'October', 'November', 'December'];
          return months[month] + ' ' + day;
        }
      } catch(e) {
        return '';
      }
    }

    function getCurrentVariantId() {
      // Najpierw pole glownego przycisku produktu (buy-buttons) - inne formularze na stronie (np. karty w koszyku) tez maja name="id"
      var main = document.querySelector('input.product-variant-id');
      if (main && main.value && variantData[String(main.value)]) return String(main.value);
      var input = document.querySelector('input[name="id"]');
      if (input && input.value) return String(input.value);
      var select = document.querySelector('select[name="id"]');
      if (select && select.value) return String(select.value);
      var keys = Object.keys(variantData);
      return keys.length > 0 ? keys[0] : null;
    }

    function getDeliveryMessage() {
      var now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Warsaw' }));
      var day = now.getDay();
      var hours = now.getHours();
      var past = hours >= settings.cutoffHour;

      /* Stopka 3.0 r5 (26.10): dni wolne w Polsce (11.11, 24-26.12, Wielkanoc…) z tej samej funkcji co data dostawy
         w koszyku. Wysyłka dziś = tekst dnia „przed”, następnego dnia = „po”, weekend z wysyłką w poniedziałek i dostawą
         we wtorek = tekst weekendu; każdy inny dzień wysyłki (piątek po godzinie granicznej, przed świętem) = „Kup teraz -
         wysyłka <dzień>” z locales (sections.shop_benefits), bo teksty dni z ustawień go nie mają (.pl w piątek po 15:00
         mówiło „jutro”). Bez svDeliveryCalc albo przy złej dacie liczenie niżej, jak dotąd. */
      var C = window.svDeliveryCalc, KEYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
      if (C && !isNaN(now.getTime()) && settings.shipOn && settings.shipDays.length === 7) {
        var ship = C.shipDay(now, settings.cutoffHour);
        var n = Math.round((new Date(ship.getFullYear(), ship.getMonth(), ship.getDate()) - new Date(now.getFullYear(), now.getMonth(), now.getDate())) / 864e5);
        var txt = '';
        if (n === 0) txt = settings.deliveryTexts[KEYS[day] + '_before'];
        else if (n === 1 && day >= 1 && day <= 4) txt = settings.deliveryTexts[KEYS[day] + '_after'];
        else if ((day === 0 || day === 6) && ship.getDay() === 1 && C.addWork(ship, 1).getDay() === 2) txt = settings.deliveryTexts[KEYS[day]];
        return txt || settings.shipOn.replace('[dzien]', settings.shipDays[ship.getDay()]);
      }

      var dayKey;
      if (day === 1) dayKey = past ? 'monday_after' : 'monday_before';
      else if (day === 2) dayKey = past ? 'tuesday_after' : 'tuesday_before';
      else if (day === 3) dayKey = past ? 'wednesday_after' : 'wednesday_before';
      else if (day === 4) dayKey = past ? 'thursday_after' : 'thursday_before';
      else if (day === 5) dayKey = past ? 'friday_after' : 'friday_before';
      else if (day === 6) dayKey = 'saturday';
      else dayKey = 'sunday';

      return settings.deliveryTexts[dayKey] || (settings.lang === 'pl' ? 'Dostawa wkrótce' : 'Delivery soon');
    }

    function update() {
      try {
        var id = getCurrentVariantId();
        if (!id) {
          deliveryBadgeText.textContent = getDeliveryMessage();
          return;
        }

        var variant = variantData[id];
        if (!variant) {
          deliveryBadgeText.textContent = getDeliveryMessage();
          deliveryBadge.className = 'shop-highlight-badge shop-highlight-badge-black show-pulse-dot';
          return;
        }

        if (!variant.available || variant.inventory <= 0) {
          var formattedDate = formatDate(variant.preorder_date);
          if (formattedDate) {
            deliveryBadgeText.textContent = settings.preorderText + ' ' + formattedDate;
          } else {
            deliveryBadgeText.textContent = settings.outOfStockText;
          }
          deliveryBadge.className = 'shop-highlight-badge shop-highlight-badge-out-of-stock show-out-of-stock';
        } else {
          deliveryBadgeText.textContent = getDeliveryMessage();
          deliveryBadge.className = 'shop-highlight-badge shop-highlight-badge-black show-pulse-dot';
        }
      } catch(e) {
        deliveryBadgeText.textContent = getDeliveryMessage();
      }
    }

    document.addEventListener('change', function(e) {
      if (e.target && e.target.name) {
        var name = e.target.name.toLowerCase();
        if (name === 'id' || name.indexOf('option') !== -1) {
          setTimeout(update, 50);
        }
      }
    });

    document.addEventListener('click', function(e) {
      var label = e.target.closest ? e.target.closest('label') : null;
      if (label) setTimeout(update, 100);
    });

    /* perf 30.09 B-07: zamiast odpytywania DOM co 300 ms przez cale zycie strony - zmiana wariantu z motywu
       (product-info.js publikuje PUB_SUB_EVENTS.variantChange oraz wysyla 'change' na input[name="id"], lapany wyzej). */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function() {
        setTimeout(update, 0);
      });
    }

    /* perf 30.09 B-07 (M-2): tekst zalezy od godziny (cutoff, polnoc w Warszawie), a bez zmiany wariantu nic go nie odswiezalo
       (dawny interwal 300 ms tez nie - wolal update() tylko przy zmianie id). Jeden timer do najblizszej granicy + odswiezenie
       po powrocie do karty i po przywroceniu strony z pamieci przegladarki (timery w tle sa zwalniane albo wstrzymane). */
    function scheduleBoundaryUpdate() {
      try {
        var now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Warsaw' }));
        var next = new Date(now.getTime());
        if (now.getHours() < settings.cutoffHour) {
          next.setHours(settings.cutoffHour, 0, 5, 0);
        } else {
          next.setDate(next.getDate() + 1);
          next.setHours(0, 0, 5, 0);
        }
        var ms = Math.min(Math.max(next.getTime() - now.getTime(), 1000), 6 * 3600 * 1000);
        setTimeout(function() { update(); scheduleBoundaryUpdate(); }, ms);
      } catch (e) {}
    }
    scheduleBoundaryUpdate();
    document.addEventListener('visibilitychange', function() { if (!document.hidden) update(); });
    window.addEventListener('pageshow', function(e) { if (e.persisted) update(); });

    setTimeout(update, 200);
  }

  function init() {
    document.querySelectorAll('script[data-sv-benefits-config]').forEach(initBenefits);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
